var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticClass: "loader-spinner fill-current",
      attrs: { viewBox: "0 0 32 32" },
    },
    [
      _c("circle", {
        staticClass: "loader-spinner__path stroke-current",
        attrs: {
          cx: "16",
          cy: "16",
          r: "14",
          fill: "none",
          "stroke-width": "4",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }